import React, { MouseEvent } from 'react';
import { useTheme } from '@mui/material';
import { CustomMUIButton } from '../../../buttons/CustomMUIButton';
import { ButtonClassNames } from '../../../../../models/Common';
import { ReactComponent as FirstPageIcon } from '../../../../../assets/images/pagination/FirstPageIcon.svg';
import { ReactComponent as LastPageIcon } from '../../../../../assets/images/pagination/LastPageIcon.svg';
import { ReactComponent as PreviousPageIcon } from '../../../../../assets/images/pagination/PreviousPageIcon.svg';
import { ReactComponent as NextPageIcon } from '../../../../../assets/images/pagination/NextPageIcon.svg';

interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (event: MouseEvent<HTMLButtonElement>, newPage: number) => void;
}

export function TablePaginationActions(props: TablePaginationActionsProps) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className="pagination-buttons">
      <CustomMUIButton
        label={theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        handleClick={handleFirstPageButtonClick}
        className={ButtonClassNames.IconPaginationFulfilled}
        isDisabled={page === 0}
      />
      <CustomMUIButton
        label={theme.direction === 'rtl' ? <NextPageIcon /> : <PreviousPageIcon />}
        handleClick={handleBackButtonClick}
        className={ButtonClassNames.IconPaginationFulfilled}
        isDisabled={page === 0}
      />
      <CustomMUIButton
        label={theme.direction === 'rtl' ? <PreviousPageIcon /> : <NextPageIcon />}
        handleClick={handleNextButtonClick}
        className={ButtonClassNames.IconPaginationFulfilled}
        isDisabled={page >= Math.ceil(count / rowsPerPage) - 1}
      />
      <CustomMUIButton
        label={theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        handleClick={handleLastPageButtonClick}
        className={ButtonClassNames.IconPaginationFulfilled}
        isDisabled={page >= Math.ceil(count / rowsPerPage) - 1}
      />
    </div>
  );
}
